// Le whitelabel.config.json (raiz do repositorio, servido pelo nginx em
// GET /whitelabel.config.json - ver infra/deploy) e aplica em runtime: nao
// precisa rebuild do M7 pra trocar logo/cores/favicon, so editar o arquivo
// e recarregar a pagina.

export interface WhitelabelConfig {
  brand: {
    name: string;
    shortName: string;
    logoUrl: string;
    faviconUrl: string;
  };
  theme: {
    colors: Record<string, string>;
    fontFamily: string;
    borderRadius: string;
  };
  map: {
    styleUrl: string;
    centroInicial: { lat: number; lon: number; zoom: number };
  };
}

let cache: WhitelabelConfig | null = null;

export async function carregarWhitelabel(): Promise<WhitelabelConfig> {
  if (cache) return cache;
  const resp = await fetch("/whitelabel.config.json");
  if (!resp.ok) {
    throw new Error(`falha ao carregar whitelabel.config.json: ${resp.status}`);
  }
  cache = (await resp.json()) as WhitelabelConfig;
  return cache;
}

export function aplicarTema(config: WhitelabelConfig): void {
  document.title = config.brand.name;

  const faviconLink = document.getElementById("favicon-link") as HTMLLinkElement | null;
  if (faviconLink) faviconLink.href = config.brand.faviconUrl;

  const root = document.documentElement.style;
  for (const [chave, valor] of Object.entries(config.theme.colors)) {
    // primary -> --color-primary, sidebarBackground -> --color-sidebar-background
    const nomeVar = "--color-" + chave.replace(/([A-Z])/g, "-$1").toLowerCase();
    root.setProperty(nomeVar, valor);
  }
  root.setProperty("--font-family", config.theme.fontFamily);
  root.setProperty("--border-radius", config.theme.borderRadius);
}
